<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="siteForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="hasClaim('Sites', true)">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="site" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                siteForm: () => import('../forms/SiteForm'),
                site: () => import('../editViews/Site'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Name', value: 'name' },
                    { text: 'Coordinates', value: 'coordinates', format: this.formatCoordinates },
                    { text: 'Landowner', value: 'landownerId', table: 'landowners', form: () => import('../forms/LandownerForm') },
                    { text: 'Nearest Town', value: 'nearestTown' },
                    { text: 'Produce', value: 'produce' },
                    { text: 'Is Near GMO', value: 'isNearGmo' },
                    { text: 'Is Farm', value: 'isFarm' },
                    { text: 'Requires Key To Access', value: 'requiresKeyToAccess' },
                    { text: 'Must Contact Landowner To Access', value: 'mustContactLandownerToAccess' },
                    { text: 'Notes', value: 'notes' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    landowners: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'sites',
                editPageName: 'site',
                apiMethod: 'Sites',
                claimName: 'Sites',
                formTitle: 'Site',
                excelTitle: 'Sites',
                hasEditPage: true,
            }
        },
    };
</script>
